import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'produto-promocao-percentual',
  templateUrl: './produto-promocao-percentual.component.html',
  styleUrls: ['./produto-promocao-percentual.component.scss']
})
export class ProdutoPromocaoPercentualComponent implements OnInit {

  @Input("percentual") percentual:any = 0; 

  public tags = [{
    image: "/images/promocao/bg-12.png" 
  },{
    image: "/images/promocao/bg-20.png"
  },{
    image: "/images/promocao/bg-50.png" 
  }];
  public tag         = null;
  public classCustom = "";

  constructor(){} 
  
  /**
   * 
   * Set tag
   * 
   */
  setTag(){ 

    if(this.percentual < 20){
      this.tag = this.tags[0].image;
      this.classCustom = "tag-01";
    }else if(this.percentual < 50){
      this.tag = this.tags[1].image;
      this.classCustom = "tag-02";
    }else{
      this.tag = this.tags[2].image;
      this.classCustom = "tag-03";
    }

  }
  /**
  * 
  * Inicializa as Funções
  * 
  */
  ngOnInit(){ 
    this.setTag();
  }

}
